import type { Exam, ExamState } from '../../exam.js';
import { createToolbox, type Toolbox } from './toolbox.js';

/**
 * Single lazily-created toolbox shared by generateAnswer, the workflow agent and the prompt builder.
 *
 * Lazy on purpose: creating it at module-load time runs during the
 * toolbox.ts → index.ts → grading-agent.tool.ts → workflow-agent.ts → prompts.ts circular import,
 * before the Toolbox class is defined, throwing "Toolbox is not a constructor". Deferring creation
 * to first call sidesteps that entirely, and lets this neutral module break the
 * prompts.ts → generate-answer.ts cycle (prompts imports getAvailableTools from here instead).
 */
let _toolbox: Toolbox | null = null;

export function getToolbox(): Toolbox {
  if (!_toolbox) _toolbox = createToolbox();
  return _toolbox;
}

/** `exam`/`role` are optional: tools whose availability depends on the task tree or the session's account
 * kind need them (see ToolAvailability). */
export function getAvailableTools(examState: ExamState, exam?: Exam, role?: 'teacher' | 'student'): any[] {
  return getToolbox().getAvailableToolSchemas(examState, exam, role) as any[];
}
